<template>
  <div v-if="isVisible">
    <div>
      <modal-mask></modal-mask>
    </div>

    <div class="exchange-success-modal">
      <div class="popup-header" :style="`color: ${h5ConfigDetails[0]['fontColor']['secondaryPopTitleColor'][0]};color: ${h5ConfigDetails[0]['fontColor']['secondaryPopTxtColor'][0]};`">兑换失败</div>
      <img :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${h5ConfigDetails[0]['wholeImg']['secondaryPopClose'][0]}`" class="close-btn" @click="closePopup" alt="">

      <div class="gift-box">
        <img :src="require('@/assets/fengyou/fail.png')" alt="礼品盒" class="gift-img" />
      </div>

      <p class="success-desc">兑换失败，请重试 <span>(失败原因：{{FAIL_REASON[retcode] || -1}})</span> 。如多次兑换仍不成功，请联系客服处理。</p>

      <div class="btn-group">
        <div class="cancle" @click="closePopup" :style="`color: ${h5ConfigDetails[0]['fontColor']['secondaryPopCancleBtnTxtColor'][0]};background: ${h5ConfigDetails[0]['fontColor']['secondaryPopCancleBtnBg'][0]};`">取消</div>
        <div class="retry" @click="retry" :style="`color: ${h5ConfigDetails[0]['fontColor']['secondaryPopBtnTxtColor'][0]};background: ${h5ConfigDetails[0]['fontColor']['secondaryPopBtnBg'][0]};`">重试</div>
      </div>
    </div>
  </div>
</template>

<script>
import { baseUrl } from '@/config/env'
import { mapState } from 'vuex'
import ModalMask from '@/components/modal/ModalMask'

const FAIL_REASON = {
  1: '1，兑换出错',
  2: '2，当前手机号无法兑换',
  3: '3，兑换出错',
  4: '3，兑换出错'
}

export default {
  name: 'ExchangeSuccessPopup',
  data () {
    return {
      baseUrl
    }
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    retcode: {
      type: Number,
      default: -1
    },
  },
  components: { ModalMask },
  methods: {
    closePopup() {
      this.$emit('close-modal')
    },
    retry () {
      this.$emit('retry-exchange')
    }
  },
  computed: {
    ...mapState(['h5ConfigDetails', 'h5ConfigImgPath']),
    FAIL_REASON: () => FAIL_REASON // 通过计算属性暴露给模板
  }
};
</script>

<style scoped lang="less">
@import '../../style/mixin';

.exchange-success-modal {
  .modal-common;
  width: 29.7rem;
  height: 25.3rem;
  background: #FFF7EE;
  text-align: center;
  border-radius: .9rem;
  padding: 1.7rem 2.1rem 1.4rem;
}

.popup-header {
  position: relative;
  margin-bottom: 1rem;
  font-weight: 500;
  font-size: 1.8rem;
  color: #7E3E1B;
}

.close-btn {
  position: absolute;
  top: .8rem;
  right: 1.1rem;
  width: 1.9rem;
  height: 1.9rem;
}

.gift-img {
  width: 9.2rem;
  height: auto;
  margin-bottom: .5rem;
}

.success-desc {
  font-weight: 400;
  font-size: 1.1rem;
  line-height: 1.5;
  text-align: left;
  margin-bottom: 2.5rem;
}

.detail-link {
  color: #FF5258;
  text-decoration: none;
}

.btn-group {
  display: flex;
  justify-content: space-between;
  align-items: center;
  div {
    width: 12rem;
    height: 4rem;
    line-height: 4rem;
    border-radius: 2rem;
    font-weight: 600;
    font-size: 1.6rem;
    color: #FFF;
  }
  .cancle {
    background: #4A4A4A;
  }
  .retry {
    background: #FA733C;
  }
}
</style>